/** @format */
import { Market, MarketCode } from '@toucan/config/markets';

import { Query } from '@toucan/client/features/search/config/types';

export function getModelIdFromSlugQuery(
    slug: string,
    marketCode: MarketCode
): Query {
    return {
        fieldList: ['model_id'],
        filterQuery: {
            modelMarket: marketCode,
            objectType: 'model',
            modelUrlSegment: `"${slug}"`,
        },
        rows: 1,
    };
}

export function getModelStockInfoQuery(
    modelId: string,
    activeMarket: Market,
    productIdToExclude?: number
) {
    const { code: market } = activeMarket;
    const search: Query = {
        fieldList: [
            'product_price.minimum',
            'product_price.maximum',
            'product_price.count',
        ],
        filterQuery: {
            modelId,
            modelMarket: market,
            objectType: 'product',
            modelAvailable: true,
        },
        start: 0,
        rows: 1,
        groupField: 'model_id',
    };

    if (productIdToExclude && search?.filterQuery) {
        search.filterQuery.productId = `NOT ${productIdToExclude}`;
    }

    return search;
}
